<template>
  <div class="bol-template">
    <div class="header">
      <div class="left">Date:</div>
      <div class="middle"><h1 class="title">BILL OF LADING</h1></div>
      <div class="left">{{ pageIndex }} / {{ totalPageCount }}</div>
    </div>
    <div class="content">
      <div class="left">
        <div class="ship-from">
          <div class="ship-from-title sub-title">SHIP FROM</div>
          <div class="ship-from-content sub-content">
            <div
              class="item"
              v-for="(item, index) in shipFromData"
              :key="'ship-from-item-' + index"
            >
              {{ item.label }}: {{ item.value }}
            </div>
          </div>
        </div>
        <div class="ship-to">
          <div class="ship-to-title sub-title">SHIP TO</div>
          <div class="ship-to-content sub-content">
            <div
              class="item"
              v-for="(item, index) in shipToData"
              :key="'ship-to-item-' + index"
            >
              {{ item.label }}: {{ item.value }}
            </div>
          </div>
        </div>
        <div class="third-party">
          <div class="third-party-title sub-title">
            THIRD PARTY FREIGHT CHARGES BILL TO
          </div>
          <div class="third-party-content sub-content">
            <div
              class="item"
              v-for="(item, index) in thirdPartyBillData"
              :key="'third-party-item-' + index"
            >
              {{ item.label }}: {{ item.value }}
            </div>
          </div>
        </div>
        <div class="special-instructions sub-content">
          <div class="special-instructions-title">
            SPECIAL INSTRUCTIONS:
            <svg-icon
              v-if="showAddFbaButton"
              icon-class="edit"
              class="edit-icon"
              @click.native="addInstruction()"
            />
          </div>
          <div class="special-instructions-content">
            {{ specialInstructions }}
          </div>
        </div>
      </div>
      <div class="right">
        <div class="bol-number sub-content">
          <div class="bol-number-title">
            {{ bolNumber.label }}
          </div>
          <div class="bol-number-content">
            {{ bolNumber.value }}
          </div>
          <img id="qrcode" :src="src" />
        </div>
        <div class="carrier sub-content">
          <div class="carrier-content">
            <div
              class="item"
              v-for="(item, index) in carrierData"
              :key="'carrier-item-' + index"
            >
              {{ item.label }}: {{ item.value }}
            </div>
          </div>
        </div>
        <div class="sticker"></div>
        <div class="freight-charge-terms sub-content">
          <div class="freight-charge-terms-title">
            Freight Charge Terms:
            <span class="tips"
              >(freight charges are prepaid unless marked otherwise)</span
            >
          </div>
          <div class="freight-charge-terms-content">
            <div
              class="options"
              v-for="(item, index) in freightChargeTermsOptions"
              :key="'freight-charge-terms-option-' + index"
            >
              <span>{{ item.label }}</span>
              <svg-icon
                icon-class="xmark"
                class="xmark"
                v-if="selectedFreightChargeTermsOption === item.key"
              />
            </div>
          </div>
        </div>
        <div class="master-bol sub-content">
          <div class="master-bol-content">
            <span
              >Master Bill of Lading: with attached underlying Bills of
              Lading</span
            >
            <svg-icon icon-class="xmark" class="xmark" />
          </div>
        </div>
      </div>
    </div>
    <div class="order-info">
      <div class="order-info-title sub-title">CUSTOMER ORDER INFORMATION</div>
      <div class="order-info-table">
        <el-row class="each-row">
          <el-col
            v-for="(header, index) in [...goodsHeaders, ...goodsHeaders]"
            :key="'header-' + index"
            class="each-col goods-header"
            :class="setWidth(index)"
          >
            {{ header.label }}
          </el-col>
        </el-row>
        <el-row
          v-for="(row, indexOne) in goodsList
            .slice(0, BolGoodsCntPerPagePerCol)
            .map((arr, index) =>
              arr.concat(
                goodsList.slice(BolGoodsCntPerPagePerCol, goodsCntPerPage)[
                  index
                ]
              )
            )"
          :key="'row-' + indexOne"
          class="each-row"
        >
          <el-col
            v-for="(col, indexTwo) in row"
            :key="'col-' + indexTwo"
            class="each-col"
            :class="setFontAndWidth(col, indexTwo)"
            :style="{ fontSize: goodsFontSize + 'px !important' }"
          >
            <el-button
              class="addFbaBtn"
              v-if="
                showAddFbaButton &&
                row[0] != '' &&
                indexTwo === 3 &&
                row[indexTwo] === ''
              "
              @click="addFba(goodsIdList[indexOne])"
            >
              Add FBA
            </el-button>
            <el-button
              class="addFbaBtn"
              v-else-if="
                showAddFbaButton &&
                row[5] != '' &&
                indexTwo === 8 &&
                row[indexTwo] === ''
              "
              @click="addFba(goodsIdList[BolGoodsCntPerPagePerCol + indexOne])"
            >
              Add FBA
            </el-button>
            <div v-else-if="indexTwo === 0 || indexTwo === 5" class="f-r-vc">
              <svg-icon
                v-if="showAddFbaButton"
                icon-class="edit"
                class="edit-icon"
                @click.native="
                  editGoods(
                    indexTwo === 0
                      ? indexOne
                      : indexOne + BolGoodsCntPerPagePerCol
                  )
                "
              />
              <span>{{ col }}</span>
            </div>
            <span v-else>{{ col }}</span>
            <div class="divider" v-if="indexTwo !== row.length - 1"></div>
          </el-col>
        </el-row>
      </div>
      <div class="total-pallet">
        <div class="total-pallet-title sub-content">GRAND TOTAL PALLET</div>
        <div class="total-pallet-content sub-content"></div>
      </div>
      <div class="ps-container">
        <div class="ps sub-content">
          {{ ps }}
        </div>
        <div class="shipper-signature-one-container">
          <div class="shipper-signature-one-text sub-content">
            The carrier shall not make delivery of this shipment without payment
            of freight and all other lawful charges.
          </div>
          <div class="signature-one-container sub-content">
            <div class="signature"></div>
            <div class="signature-text">Shipper Signature</div>
          </div>
        </div>
      </div>
      <div class="signature-container">
        <div class="shipper-signature-two-container sub-content">
          <div class="shipper-signature-two-title">
            SHIPPER SIGNATURE / DATE
          </div>
          <div class="shipper-signature-two-text">
            This is to certify that the above named materials are properly
            classified, described, packaged, marked and labeled, and are in
            proper condition for transportation according to the applicable
            regulations of the U.S. DOT.
          </div>
          <div class="shipper-signature-two"></div>
        </div>
        <div class="trailer-loaded sub-content">
          <div class="trailer-loaded-tilte">Trailer Loaded</div>
          <div
            class="small-options"
            v-for="(item, index) in trailerLoadedOptions"
            :key="'trailer-loaded-option-' + index"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
        <div class="freight-counted sub-content">
          <div class="freight-counted-tilte">Freight Counted</div>
          <div
            class="small-options"
            v-for="(item, index) in freightCountedOptions"
            :key="'freight-counted-option-' + index"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
        <div class="carrier-signature-container sub-content">
          <div class="carrier-signature-title">
            CARRIER SIGNATURE / PICKUP DATE
          </div>
          <div class="carrier-signature-text">
            Carrier acknowledges receipt of packages and required placards.
            Carrier certifies emergency response information was made available
            and/or carrier has the U.S. DOT emergency response guidebook or
            equivalent documentation in the vehicle.
          </div>
          <div class="carrier-signature"></div>
          <div class="carrier-signature-tips">
            Property described above is received in good order, except as noted.
          </div>
        </div>
      </div>
    </div>
    <add-fba-dialog ref="addFbaDialog" />
    <add-bol-instruction ref="addBolInstruction" />
    <bol-goods-edit ref="bolGoodsEdit" />
  </div>
</template>

<script>
import QRCode from 'qrcode'
// others
import cloneDeep from 'lodash/cloneDeep'
// api
import { queryGoods } from '@/api/goods'
// import { modifyShipment } from '@/api/shipment'
// models
import {
  BolGoodsCntPerPagePerCol,
  BolGoodsCntPerPage
} from '@/core/models/shipment'
// components
import AddFbaDialog from '@/components/shipment/AddFbaDialog.vue'
import AddBolInstruction from '@/components/shipment/AddBolInstruction.vue'
import BolGoodsEdit from '@/components/shipment/BolGoodsEdit.vue'
// msg
// import PagesMessage from '@/core/message/pages'

export default {
  name: 'BolTemplate',
  components: {
    AddFbaDialog,
    AddBolInstruction,
    BolGoodsEdit
  },
  props: {
    shipmentNo: {
      type: String,
      required: true
    },
    shipmentId: {
      type: String,
      required: true
    },
    truckInfo: {
      type: Object,
      required: true
    },
    thirdPartyBillInfo: {
      type: Object,
      required: true
    },
    groupName: {
      type: String,
      required: true
    },
    goodsIds: {
      type: Array,
      required: true
    },
    palletCnt: {
      type: Number,
      required: true
    },
    bolInfo: {
      type: Object,
      required: true
    },
    showAddFbaButton: {
      type: Boolean,
      default: true
    },
    totalPageCount: {
      type: Number,
      required: true
    },
    pageIndex: {
      type: Number,
      required: true
    },
    goodsFontSize: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      shipFromData: [
        { label: 'Name', value: 'RII EXPRESS', key: 'shipFromName' },
        {
          label: 'Address',
          value: '14950 VALLEY VIEW AVE',
          key: 'shipFromAddressOne'
        },
        {
          label: 'City/State/Zip',
          value: 'LA MIRADA, CA 90638',
          key: 'shipFromAddressTwo'
        },
        { label: 'Attn', value: '', key: 'shipFromAttn' },
        { label: 'FOB', value: '', key: 'shipFromFob' }
      ],
      shipToData: [
        { label: 'Name', value: '', key: 'name' },
        { label: 'Address', value: '', key: 'address' },
        { label: 'City/State/Zip', value: '', key: 'cityStateZip' },
        { label: 'Contact', value: '', key: 'shipToContact' },
        { label: 'FOB', value: '', key: 'shipToFob' }
      ],
      thirdPartyBillData: [
        { label: 'Name', value: '', key: 'name' },
        { label: 'Address', value: '', key: 'address' },
        { label: 'City/State/Zip', value: '', key: 'cityStateZip' }
      ],
      bolNumber: {
        label: 'BILL OF LADING NUMBER:',
        value: 'RIIT' + this.shipmentNo,
        key: 'bolNumber'
      },
      carrierData: [
        { label: 'CARRIER NAME', value: '', key: 'truckCompany' },
        { label: 'Trailer Number', value: '', key: 'trailerNo' },
        { label: 'Seal Number', value: '', key: 'sealNo' }
      ],
      freightChargeTermsOptions: [
        { label: 'Prepaid', key: 'prepaid' },
        { label: 'Collect', key: 'collect' },
        { label: 'C.O.D.', key: 'cod' }
      ],
      selectedFreightChargeTermsOption: 'prepaid',
      orderInfoHeaders: [],
      ps: `RECEIVED, subject to individually determined rates or contracts that 
           have been agreed upon in writing between the carrier and shipper, if 
           applicable, otherwise to the rates, classifications and rules that have 
           been established by the carrier and are available to the shipper, on request, 
           and to all applicable state and federal regulations.`,
      trailerLoadedOptions: [
        { label: 'By Shipper', key: 'byShipper' },
        { label: 'By Driver', key: 'byDriver' }
      ],
      freightCountedOptions: [
        { label: 'By Shipper', key: 'byShipper' },
        { label: 'By Driver/pallets said to contain', key: 'byDriverPallets' },
        { label: 'By Driver/Pieces', key: 'byDriverPieces' }
      ],
      src: '',
      goodsHeaders: [
        {
          label: 'Customer Ref#',
          key: 'sku'
        },
        {
          label: 'Reference ID',
          key: 'referenceNo'
        },
        {
          label: 'QTY',
          key: 'quantity'
        },
        {
          label: 'Shipment ID',
          key: 'shipmentNo'
        },
        {
          label: 'Weight',
          key: 'kilograms'
        }
      ],
      goodsList: [],
      goodsIdList: [],
      goodsCntPerPage: BolGoodsCntPerPage,
      specialInstructions: '',
      BolGoodsCntPerPagePerCol
    }
  },
  methods: {
    async getSrc() {
      this.src = await QRCode.toDataURL(
        JSON.stringify({
          type: 'Shipment',
          no: this.shipmentNo,
          id: this.shipmentId
        }),
        {
          margin: 0,
          width: 100,
          height: 100
        }
      )
    },
    getGoodsInfo(goods) {
      const res = []
      this.goodsHeaders.forEach(header => {
        res.push(goods[header.key] ?? '')
      })
      return res
    },
    fillEmptyRows(num) {
      const emptyRow = Array(this.goodsHeaders.length).fill('')
      const emptyRows = Array(num).fill(emptyRow)
      return emptyRows
    },
    addFba(goodsId) {
      this.$refs.addFbaDialog.open(goodsId)
    },
    addInstruction() {
      this.$refs.addBolInstruction.open(
        this.specialInstructions,
        this.setInstruction
      )
    },
    setInstruction(value) {
      this.$set(this, 'specialInstructions', value)
      // modifyShipment(this.shipmentId, { bols: [{ name: this.groupName, instruction: value }] }).then(res => {
      //   PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_BOL)
      // })
    },
    editGoods(index) {
      this.$refs.bolGoodsEdit.open(this.goodsList[index], this.setGoods(index))
    },
    setGoods(index) {
      return arr => this.$set(this.goodsList, index, arr)
    },
    setFontSize(text) {
      if (text.length > 24) {
        return 'smaller-font'
      } else if (text.length > 20) {
        return 'small-font'
      }
    },
    setWidth(index) {
      switch (index) {
        case 1:
        case 6:
          return 'narrow-col-1'
        case 2:
        case 7:
          return 'narrow-col-3'
        case 3:
        case 8:
          return 'narrow-col-0'
        case 4:
        case 9:
          return 'narrow-col-2'
        default:
          return ''
      }
    },
    setFontAndWidth(text, index) {
      const classNames = []
      // if (this.setFontSize(text)) classNames.push(this.setFontSize(text))
      if (this.setWidth(index)) classNames.push(this.setWidth(index))
      return classNames
    }
  },
  watch: {
    thirdPartyBillInfo: {
      handler() {
        const curr = cloneDeep(this.thirdPartyBillData)

        curr.forEach(e => {
          e.value = this.thirdPartyBillInfo[e.key]
        })
        if (
          this.thirdPartyBillInfo.city &&
          this.thirdPartyBillInfo.state &&
          this.thirdPartyBillInfo.zip
        ) {
          curr[curr.findIndex(e => e.key === 'cityStateZip')].value =
            this.thirdPartyBillInfo.city +
            '/' +
            this.thirdPartyBillInfo.state +
            '/' +
            this.thirdPartyBillInfo.zip
        }
        this.$set(this, 'thirdPartyBillData', curr)
      },
      immediate: true
    },
    goodsIds: {
      handler() {
        if (this.goodsList.length > 0) return
        queryGoods({ ids: this.goodsIds, size: -1 }).then(res => {
          const goodsList = res.records
          const list = []
          const goodsIdList = []
          goodsList.forEach(goods => {
            const goodsInfo = this.getGoodsInfo(goods)
            list.push(goodsInfo)
            goodsIdList.push(goods.id)
          })
          list.push(...this.fillEmptyRows(this.goodsCntPerPage - list.length))
          this.$set(this, 'goodsList', list)
          this.$set(this, 'goodsIdList', goodsIdList)
        })
      },
      immediate: true
    },
    bolInfo: {
      handler() {
        this.shipToData[
          this.shipToData.findIndex(e => e.key === 'name')
        ].value = this.bolInfo.name
        this.shipToData[
          this.shipToData.findIndex(e => e.key === 'address')
        ].value = this.bolInfo.address
        if (this.bolInfo.city && this.bolInfo.state && this.bolInfo.zip) {
          this.shipToData[
            this.shipToData.findIndex(e => e.key === 'cityStateZip')
          ].value =
            this.bolInfo.city +
            '/' +
            this.bolInfo.state +
            '/' +
            this.bolInfo.zip
        }
        this.specialInstructions = this.bolInfo.instruction
      },
      immediate: true
    },
    truckInfo: {
      handler() {
        this.carrierData[
          this.carrierData.findIndex(e => e.key === 'truckCompany')
        ].value = this.truckInfo.truckCompany
        this.carrierData[
          this.carrierData.findIndex(e => e.key === 'trailerNo')
        ].value = this.truckInfo.trailerNo
        this.carrierData[
          this.carrierData.findIndex(e => e.key === 'sealNo')
        ].value = this.truckInfo.sealNo
      },
      immediate: true
    }
  },
  mounted() {
    this.getSrc()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';
$basic-form-divider-width: 1px;
$basic-form-border-color: #dcdfe6;

* {
  box-sizing: border-box;
  font-weight: lighter;
  color: black;
}

.bol-template {
  @extend .f-c;

  width: 21cm !important;
  height: 29.8cm !important;
  background-color: white;

  .header {
    border: $basic-form-divider-width solid;
    border-bottom: none;
    padding: 0 10px;

    @extend .f-r-vc;

    .middle {
      margin: 0 auto;
      width: 260px;

      .title {
        text-align: center;
        font-size: 25px;
        font-weight: bold;
        margin: 0;
      }
    }
  }

  .sub-title {
    @extend .f-r-hc;

    font-size: 13px;
    font-weight: bold;
    padding: 2px;
    color: white;
    background-color: black;
  }

  .sub-content {
    font-size: 13px;
    padding: 2px;
  }

  .small-options {
    font-size: 12px;
  }

  .content {
    @extend .f-r;

    .left {
      @extend .f-c;

      width: 60%;
      border: $basic-form-divider-width solid;
      border-bottom: none;

      .special-instructions {
        border-top: $basic-form-divider-width solid;

        .special-instructions-content {
          min-height: 40px;
        }
      }
    }

    .right {
      width: calc(40% + $basic-form-divider-width);
      border: $basic-form-divider-width solid;
      border-bottom: none;
      border-left: none;

      .carrier {
        border-top: $basic-form-divider-width solid;
      }

      .sticker {
        border-top: $basic-form-divider-width solid;
        height: 80px;
      }

      .freight-charge-terms {
        border-top: $basic-form-divider-width solid;

        .tips {
          font-size: 12px;
        }

        .freight-charge-terms-content {
          @extend .f-r;

          justify-content: space-evenly;
        }
      }

      .master-bol {
        border-top: $basic-form-divider-width solid;

        .master-bol-content {
          @extend .f-r-vc;

          .xmark {
            width: 80px;
          }
        }
      }
    }
  }

  .order-info {
    .big-row {
      @extend .f-r;
    }

    .each-row {
      width: 100%;
      border: $basic-form-divider-width solid;
      border-right: none;
      border-bottom: none;

      @extend .f-r;
    }

    .each-col {
      font-size: 11px;
      border-right: $basic-form-divider-width solid;
      // min-height: 23px;
      min-height: 16px;
      word-break: break-all;

      @extend .f-c-c-c;

      flex: 1;

      .addFbaBtn {
        box-sizing: border-box;
        height: 14px;
        width: 60px;
        padding: 0;
        border: none;
        font-size: 12px;
      }
    }

    .total-pallet {
      @extend .f-r;

      border: $basic-form-divider-width solid;
      border-bottom: none;

      .total-pallet-title {
        @extend .f-r-hc;

        box-sizing: border-box;
        width: 30%;
        border-right: $basic-form-divider-width solid;
      }

      .total-pallet-content {
        @extend .f-r-hc;

        width: 20%;
        border-right: $basic-form-divider-width solid;
      }
    }

    .ps-container {
      @extend .f-r;

      border: $basic-form-divider-width solid;
      border-bottom: none;

      .ps {
        width: 50%;
        border-right: $basic-form-divider-width solid;
        font-size: 10px;
      }

      .shipper-signature-one-container {
        width: 50%;

        .shipper-signature-one-text {
          font-size: 12px;
        }

        .signature-one-container {
          @extend .f-r;

          justify-content: flex-end;
          width: 95%;

          .signature {
            border-bottom: $basic-form-divider-width solid;
            flex-grow: 1;
          }
        }
      }
    }

    .signature-container {
      @extend .f-r;

      border: $basic-form-divider-width solid;

      .shipper-signature-two-container {
        width: 30%;
        border-right: $basic-form-divider-width solid;

        .shipper-signature-two-text {
          font-size: 10px;
        }

        .shipper-signature-two {
          height: 20px;
        }
      }

      .trailer-loaded {
        width: 15%;
        // border-right: solid;
      }

      .freight-counted {
        width: 18%;
        border-right: $basic-form-divider-width solid;
      }

      .carrier-signature-container {
        width: 37%;

        .carrier-signature-text {
          font-size: 10px;
        }

        .carrier-signature {
          min-height: 20px;
        }

        .carrier-signature-tips {
          font-size: 10px;
        }
      }
    }
  }
}

.goods-header {
  font-weight: bold;
}

.small-font {
  font-size: 10px !important;
}

.smaller-font {
  font-size: 8px !important;
}

.narrow-col-0 {
  flex: 0 0 95px !important;
}

.narrow-col-1 {
  flex: 0 0 85px !important;
}

.narrow-col-2 {
  flex: 0 0 50px !important;
}

.narrow-col-3 {
  flex: 0 0 35px !important;
}

::v-deep .edit-icon {
  color: blue !important;

  &:hover {
    cursor: pointer;
  }
}
</style>
